import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ACCOUNT_TABS} from 'src/constants';

import {ValidatedMicrositeConfigurations as MicrositeConfigurations} from './configurations/microsite-configurations';
import {MICROSITES_SUB_TABS} from './constants';

type Props = {
    accountId: number,
};

export const MicrositesRouter = ({accountId}: Props) => {
    return (
        <Routes>
            <Route
                path={`/${MICROSITES_SUB_TABS.CONFIGURATIONS.name}`}
                element={<MicrositeConfigurations accountId={accountId}/>}
            />

            <Route
                path="*"
                element={(
                    <Navigate
                        to={`/profile/account/${accountId}/${ACCOUNT_TABS.MICRO_SITES.name}/${MICROSITES_SUB_TABS.CONFIGURATIONS.name}`}
                    />
                )}
            />
        </Routes>
    );
};
